import { isUndefined } from 'lodash/fp';
import React from 'react';

import { Button } from '../../shared/button/Button';
import { Scrollable } from '../../shared/scrollable/Scrollable';
import styles from './SharedAdmin.module.scss';

interface DatasetTileProps {
    datasetId: number;
    documentNames: string[];
    agreementType: string;
    preview?: () => void;
    configure?: () => void;
    riskTolerance?: () => void;
    selectDataset?: () => void;
}

export const DatasetTile: React.FC<DatasetTileProps> = ({ datasetId, documentNames, agreementType, preview, configure, riskTolerance, selectDataset }) => (
    <div key={datasetId} className={styles.datasetTileWrapper}>
        <div className={styles.documentNamesWrapper}>
            <div className={styles.documentNamesHeader}>{agreementType}:</div>
            <div className={styles.documentNamesList}>
                <Scrollable>
                    <div>
                        {documentNames.map((name, i) => <div className={styles.documentName} key={i}>{name}</div>)}
                    </div>
                </Scrollable>
            </div>
        </div>
        <div className={styles.buttonWrapper}>
            {!isUndefined(preview) && <Button label='Preview' onClick={preview} />}
            {!isUndefined(configure) && <Button label='Configure' onClick={configure} />}
            {!isUndefined(riskTolerance) && <Button label='Configure' onClick={riskTolerance} />}
            {!isUndefined(selectDataset) && <Button label='Select' onClick={selectDataset} />}
        </div>
    </div>
);
